import { buttonClassName } from '@emailforge/ui';
import { Link } from 'react-router-dom';

export function ComingSoonPage({
  eyebrow,
  title,
  blurb,
  primaryCta = { label: 'Back to home', to: '/' },
}: {
  eyebrow: string;
  title: string;
  blurb: string;
  primaryCta?: { label: string; to: string };
}) {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '80px 24px 100px', textAlign: 'center' }}>
      <div
        className="mono"
        style={{
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: 0.08,
          color: 'var(--flame-2)',
          marginBottom: 10,
        }}
      >
        {eyebrow}
      </div>
      <h1 className="display" style={{ fontSize: 44, margin: '0 0 14px', letterSpacing: -0.02 }}>
        {title}
      </h1>
      <p style={{ fontSize: 16, color: 'var(--ink-2)', lineHeight: 1.6, margin: '0 auto 32px', maxWidth: 540 }}>
        {blurb}
      </p>
      <Link to={primaryCta.to} className={buttonClassName({ variant: 'flame' })}>
        {primaryCta.label}
      </Link>
    </div>
  );
}
